import React, { useEffect, useState }  from 'react';
import Badge from '@mui/material/Badge';

import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import PostAddIcon from '@material-ui/icons/PostAdd';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { red } from '@mui/material/colors';
import DoneIcon from '@mui/icons-material/Done';
import auth from '../../service/Auth'
import { experiments_view } from '../../service/apis';
import GPAP_Button from '../../../gpap-lib/Button_Collection';

import AlertMissingTable from './AlertMissingTable';
import Box from "@mui/material/Box";

const AlertMissing = (props) => {

    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]);


    let bodyPost = { 
        "page" : 1, "pageSize" : 1,
        "fields" : ["LocalExperimentID", "Owner", "ExperimentID","LOADDATE"],
        "filtered":[{"id":"Owner","value":auth.getUserGroups()}, {"id":"file_submission_close","value":["false"]}]
    }

    useEffect(() => {
        if (auth.tokenExpired()){  
            setRequest({open:false, next: false});
        } else {
            // 1. Function to get total items and all data 
            const fetchData = async () => {
                // 1.1. Get total items
                const queryItems = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyPost))
                .then((response) => { return response.json()})
                .then((dataApi) => {
                    return dataApi["_meta"]["total_items"];
                });
                // 1.2. Get No Experiments data
                if (queryItems > 0) {
                    bodyPost["pageSize"] = queryItems;
                    const dataItems = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(bodyPost))
                    .then((response) => { return response.json()})
                    .then((dataApi) => {
                        return dataApi["items"].map((item, index) => { item["id"] = index;  return item;});
                    });
                    setRows(dataItems);
                }
            }
            // 2. Call function
            fetchData().catch(console.error);
        }
    }, [])

    const closeHandler = (event) => {
        setOpen(false);
    }

    const notificationHandler = (event) => {
        setOpen(true);
    }

    const handleRedirect = () =>
    {
        window.location.href = "#/selectexperiments";
        closeHandler();
    }

    return(
        <React.Fragment>
            <Badge badgeContent={props.experimentsMissing}
                   style={{cursor:"pointer"}}
                   onClick={notificationHandler}
                   sx={{ margin:2, color: red[900] }}>
                <CrisisAlertIcon sx={{ color: red[600] }} />
            </Badge>

            <Dialog
                maxWidth={"xl"}
                open={open}
                onClose={closeHandler}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description" >
                <DialogTitle> <center> Warning issues for user {props.userName} </center> </DialogTitle>
                <DialogContent>
                    <Box p={2}>
                        <DialogContentText id="alert-dialog-description">
                            {rows.length} Experiments waiting to have file(s) metadata submitted:
                        </DialogContentText>
                        <Box p={1}>
                            <AlertMissingTable rows={rows}/>
                        </Box>

                    </Box>

                </DialogContent>
                <DialogActions>
                    <Box p={1}>
                        <GPAP_Button id="validate" onClick={handleRedirect}  startIcon={<PostAddIcon />}>
                            Associate Files
                        </GPAP_Button>
                    </Box>
                    <Box p={1}>
                        <GPAP_Button id="validate"  onClick={closeHandler}  startIcon={<DoneIcon />}>
                            Close
                        </GPAP_Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

}

export default AlertMissing;